import { HttpClient, JSON_STRING } from "../../services/http/http-client";
import { BOOKING_URL } from "../../modules/booking/services/booking-service";

export const CommentService = {
  insertComment: ({
    section,
    comment,
    table_id,
    status
  }) => {
    return HttpClient.post(BOOKING_URL, {
      section: section,
      action: 'add_location_comment',
      comment: comment,
      table_id,
      status,
      output: JSON_STRING
    })
  },
  deleteComment: ({
    section,
    comment_id,
  }) => HttpClient.post(BOOKING_URL, {
    section,
    action: 'delete_comment',
    comment_id
  })
}